module.exports = __webpack_public_path__ + "static/media/ZUT65.ef6c3cd1.pdf";